import * as React from 'react';

import {asCoreObject} from 'app-core/framework/CoreObjectIntrospectionUtils';
import CoreObjectStarIconRenderer from 'app-core/platform/starrable/CoreObjectStarIcon';
import {StarredItemsByObjectId} from 'app-core/platform/starrable/CoreObjectStarIcon';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import BaseAnalyticsListingRenderer from 'insights/sidepanel/BaseAnalyticsListingRenderer';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {AnalysisSearchAttributesGraphQL} from '../../../graphql-fragments/analysis-tool/__generated/AnalysisSearchAttributesGraphQL';

export default class AnalysisListingRenderer extends BaseAnalyticsListingRenderer<ListingRendererType.ANALYSIS> {
  listingRendererType = ListingRendererType.ANALYSIS;
  icon: BenchlingIconName = ModelTypeConstants.ANALYSIS;

  override renderStarIcon(
    item: AnalysisSearchAttributesGraphQL,
    starredItemsByObjectId?: StarredItemsByObjectId
  ): React.ReactNode {
    return (
      <CoreObjectStarIconRenderer
        item={asCoreObject(item)}
        isStarred={starredItemsByObjectId?.[item.id] ?? false}
      />
    );
  }
}
